<template>
  <div class="compound public-content">
    <div class="breadcrumb">字段管理</div>
    <div class="add-category">
      <div class="keywords">
        <span>字段名称</span>
        <el-input v-model="keywords" clearable></el-input>
      </div>
      <div>
        <el-button round type="primary" @click="changeCompound('./compoundtype')">新建字段</el-button>
        <el-button round @click="onSubmit">查询</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border :row-class-name="rowClassName">
          <el-table-column label="字段" min-width="100px" prop="sizeName"></el-table-column>
          <el-table-column label="是否启用" prop="bleedName" min-width="100px"></el-table-column>
          <el-table-column label="操作" min-width="100px">
            <template v-slot="scope">
              <span class="color-blue" @click="correlationSize(scope.row)">查看</span><br>
              <span class="color-blue" @click="correlationSize(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <CombinedDialog ref="dialogRef" @delete="deleteMenuOK" @addMenu="addMenuOK"></CombinedDialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import VPagination from '@/components/Pagination/index'
import { sizeListPaging, composeTypeDetail, bleedDetail } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    CombinedDialog,
    VPagination
  },
  data () {
    return {
      composeList: [],
      keywords: '',
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      compoundType: [],
      tableData: [{
      }]
    }
  },
  created () {
    this.getCompose(this.queryInfo)
  },
  methods: {
    onSubmit () {
      this.getCompose()
    },
    getCompose (val) {
      sizeListPaging({
        pageNum: val.pageNum,
        pageSize: val.pageSize,
        params: {
          composeTypeId: '',
          sizeName: ''
        }
      }).then((res) => {
        let _this = this
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          res.data.data.records.forEach((item) => {
            item.typeName = ''
            item.bleedType = ''
            _this.getCompoundType(item.composeTypeId).then(res => {
              item.typeName = res
            })
            _this.getBleedType(item.bleedId).then(res => {
              item.bleedType = res
            })
          })
          this.composeList = res.data.data.records
        } else {
        }
      })
    },
    async getCompoundType (id) {
      let post = () => {
        return new Promise(resolve => {
          composeTypeDetail(id).then((res) => {
            if (res.data.success) {
              resolve(res.data.data.typeName)
            }
          })
        })
      }
      let result = await post()
      return result
    },
    async getBleedType (id) {
      let post = () => {
        return new Promise(resolve => {
          bleedDetail(id).then((res) => {
            if (res.data.success) {
              resolve(res.data.data)
            }
          })
        })
      }
      let result = await post()
      return result
    },
    changeCompound (url) {
      this.$router.push(url)
    },
    deleteSize (content) {
      this.$refs.dialogRef.show('delete', '确定提示', '删除确定<br><span style="color: #999">是否确定删除</span>',
        '', 'delete', '/api/pms/admin/bleed/delete/' + `${content.id}`)
    },
    deleteMenuOK () {
      this.getCompose()
    },
    addMenuOK () {
      this.getCompose()
    },
    changePage (val) {
      this.queryInfo = val
      this.getCompose(this.queryInfo)
    }
  }
}
</script>
 <style scoped lang="less">
 .compound {
   .add-category {
     justify-content: space-between;
   }
 
   .keywords {
     display: flex;
     justify-content: space-around;
     // width: 750px;
     align-items: center;
 
     .el-input {
       width: 180px;
     }
   }
 }
 </style>
